const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/metadata/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Authenticated metadata section with a persistent collection rail. The four
 * libraries are one global `metadata-library` capability (backend PR #294), so
 * this gates on the corresponding Target operation.
 */
export const Route = createFileRoute('/_authenticated/_app/metadata')({
  beforeLoad: requireCapabilities(has => has('metadata-library.organization.read') || has('metadata-library.list')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});